var map = {
	"./connection ibh_link/default.json": 51340,
	"./connection omron/default.json": 61421,
	"./connection snap7/default.json": 73805,
	"./graficolineal/default.json": 11316,
	"./graficoquesito/default.json": 64273,
	"./image-switch-canvas/default.json": 996,
	"./image-switch-hover/default.json": 23446,
	"./label/default.json": 39578,
	"./momentaneo/default.json": 54234,
	"./navigation/default.json": 33831,
	"./selector/default.json": 82708,
	"./set_reset/default.json": 74562,
	"./silo1/default.json": 15308,
	"./silo_canvas/default.json": 96927,
	"./tank/default.json": 61879,
	"./tank_canvas/default.json": 22751,
	"./value_label write_1/default.json": 3304,
	"./value_label/default.json": 60540,
	"./value_label_write/default.json": 2705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81772;